import { map, compose, over, flatten, filter } from 'lodash/fp';
import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { OverlayedLoader, TypographyOptions } from '@mews-commander/ui';
import { getSpacingToken } from '@optimus-web/common';
import { ServiceOrderState } from '@mews-commander/legacy-data-structures';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getReservationGroup } from '@mews-commander/legacy-entities/src/ducks/reservationGroups';
import {
    getGroupNonCanceledReservationsCount,
    getReservationsByGroupId,
} from '@mews-commander/legacy-entities/src/ducks/reservations';
import ReservationGroupDetailListItem from './ReservationGroupDetailListItem';
import { ReservationList } from './styles';

const sortByServiceOrderState = compose(
    flatten,
    over([
        filter({ state: ServiceOrderState.Inquired.value }),
        filter({ state: ServiceOrderState.Optional.value }),
        filter({ state: ServiceOrderState.Requested.value }),
        filter({ state: ServiceOrderState.Confirmed.value }),
        filter({ state: ServiceOrderState.Started.value }),
        filter({ state: ServiceOrderState.Processed.value }),
    ])
);

interface Props {
    groupId: string;
    group?: {};
    selectedReservationId?: string;
    onNavigateTo?: (id: string, isReservation: boolean) => void;
}

class GroupSimpleDetail extends Component<Props> {
    mapReservations = compose(
        map((r) => (
            <ReservationGroupDetailListItem
                key={(r as $TSFixMe).id}
                {...r}
                // @ts-expect-error $TSFixMeError: Type '{ onClick: any; selected: boolean; onNavigateTo: any; state: { toString: ...; toFixed: ...; toExponential: ...; to...
                onClick={(this.props as $TSFixMe).handleReservationSelected}
                selected={(r as $TSFixMe).id === this.props.selectedReservationId}
                onNavigateTo={this.props.onNavigateTo}
            />
        )),
        sortByServiceOrderState
    );

    render() {
        // @ts-expect-error $TSFixMeError: Property 'reservations' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { group, reservations, reservationsCount } = this.props;
        if (!group) {
            return <OverlayedLoader show />;
        }

        // @ts-expect-error $TSFixMeError: Property 'name' does not exist on type '{}'.
        const { name } = group;
        return (
            <div>
                <Wrapper className="both-sides">
                    <dt>
                        <LocalizedText textKey={TextKey.ReservationGroupName} />
                    </dt>
                    <dd>
                        <TypographyOptions wordBreak="break-all">{name}</TypographyOptions>
                    </dd>
                    <dt>
                        <LocalizedText textKey={TextKey.ReservationPlural} />
                    </dt>
                    <dd>{`${reservationsCount}`}</dd>
                </Wrapper>

                <ReservationList>{this.mapReservations(reservations)}</ReservationList>
            </div>
        );
    }
}

const Wrapper = styled.dl`
    padding: 0 ${getSpacingToken('100')}px;
    margin-bottom: ${getSpacingToken('100')}px;
`;

// @ts-expect-error $TSFixMeError: Property 'groupId' does not exist on type '{}'.
export default connect((state, { groupId }) => {
    const enterpriseId = getCurrentEnterpriseId();
    return {
        // @ts-expect-error
        group: getReservationGroup(state, { id: groupId }),
        // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
        reservations: getReservationsByGroupId(state, { enterpriseId, groupId }),
        // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
        reservationsCount: getGroupNonCanceledReservationsCount(state, { enterpriseId, groupId }),
    };
})(GroupSimpleDetail);
